import getLogger from '@ignitesales/logger-es';
import { validateValue } from '../../components/Forms/formValidationHelper';

const logger = getLogger({ modules: 'validateQuestion' });

/**
 * This is used for frontend validation of answered questions
 *
 * @param question: question being validated
 * @param value: the value of the answered question
 * @returns {{}}: a validation object, or null if valid
 */

const validateQuestion = (question, value) => {
  let errors;
  const vv = question.validations || [];

  for (let v of vv) {
    let isValid = true;

    switch (v.type) {
      case 'inFootprintStates': {
        logger.info('Skipping frontend question validation for inFootprintStates, the server will handle this');
        break;
      }
      default: {
        isValid = validateValue(v.type, value, v);
        if (!isValid) {
          errors = {
            [v.type]: v.type === 'between' ? [v.min, v.max] : []
          };
        }
      }
    }
  }

  return errors;
};

export default validateQuestion;
